.empty-state {
    padding: 0 8px;
    color: var(--grey-lt);
    font-size: var(--font-normal);
    line-height: 19px;
}
